import type { TranslationFunction } from '@/app/components/translations/Translation';

/**
 * Alt text for a gallery photo, e.g. "Strand Palace, Photo 3 of 24".
 *
 * The image data is a bare list of URLs with no caption or category, so the text cannot say what the
 * photo shows. It names what the photo belongs to (the hotel or the room) and where it sits in the set
 * instead (MPH-243).
 */
export function getPhotoAlt(t: TranslationFunction, name: string | undefined, index: number, total: number) {
  const position = String(index + 1);
  const count = String(total);
  const photoPosition =
    t('vacation.select.gallery.photo_position', { position, count }) || `Photo ${position} of ${count}`;

  return name ? `${name}, ${photoPosition}` : photoPosition;
}
